import { Box } from "@mui/material";
import { useConstants } from "../hooks/UseConstants";

/** Modal shell over main content — keeps sidebar + app bar visible. */
export default function ModalOverlay({
    id,
    onClose,
    children,
    className = "",
    sx = {},
    closeOnBackdrop = true,
    fullScreen = false,
    noSidebar = false,
}) {
    const { language } = useConstants();
    const isEn = language === "en";

    const handleBackdropClick = (event) => {
        if (closeOnBackdrop && event.target === event.currentTarget) {
            onClose?.();
        }
    };

    const sidebarInset = noSidebar
        ? { left: 0, right: 0 }
        : isEn
            ? { left: "var(--sidebar-width, 272px)", right: 0 }
            : { left: 0, right: "var(--sidebar-width, 272px)" };

    const areaSx = fullScreen
        ? { position: "fixed", inset: 0, zIndex: 1100 }
        : {
            position: "fixed",
            top: "var(--app-header-height, 80px)",
            height: "calc(100vh - var(--app-header-height, 80px))",
            zIndex: 1100,
            ...sidebarInset,
        };

    return (
        <Box
            id={id}
            onClick={handleBackdropClick}
            className={className}
            sx={{
                display: "none",
                alignItems: "center",
                justifyContent: "center",
                bgcolor: "rgba(15, 23, 42, 0.42)",
                backdropFilter: "blur(3px)",
                overflowY: "auto",
                p: { xs: 1.5, sm: 2 },
                ...areaSx,
                ...sx,
            }}
        >
            <Box
                onClick={(event) => event.stopPropagation()}
                sx={{ width: "100%", maxWidth: "100%", display: "flex", justifyContent: "center", my: "auto" }}
            >
                {children}
            </Box>
        </Box>
    );
}
